import { TickChartView } from '@adiox/ui';
import { useSymbols } from '../market/useSymbols';
import { useQuoteSubscription } from '../stream/useQuoteSubscription';
import { useWorkspace } from '../workspace/workspaceStore';
import { useTickHistory } from './tickHistoryStore';

/**
 * A tick chart of the symbol picked in Market Watch: bid and ask as they reach the terminal. The server merges updates
 * to at most ten a second per symbol; the history itself keeps running in `tickHistoryStore` regardless of whether
 * this component is mounted, so reopening the chart continues where the feed is now instead of starting empty again.
 */
export function TickChart() {
  const symbol = useWorkspace((s) => s.activeSymbol) ?? 'EURUSD';
  const digits = useSymbols().data?.find((s) => s.name === symbol)?.digits ?? 5;
  const list = useTickHistory((s) => s.bySymbol[symbol]) ?? NO_TICKS;
  useQuoteSubscription([symbol]);
  return (
    <TickChartView
      symbol={symbol}
      digits={digits}
      ticks={list}
      note="Keeps running while this symbol is watched anywhere, even with this chart closed; prices arrive up to ten times a second, so very fast ticks are merged."
    />
  );
}

const NO_TICKS: never[] = [];
